import React from "react";
import { useTranslation } from "react-i18next";

import NoResults from "../../../common/NoResults";
import { SonicTeamData } from "../../../common/classes/SonicTeam";
import { SonicUserData } from "../../../common/classes/SonicUser";
import ActionBtn from "../../../common/management/ActionBtn";

import styles from "./DBList.module.scss";
import { checkForJikeiRoles } from "../../../utils/GeneralUtils";

type Props = {
  teams: Array<SonicTeamData>;
  owners: Array<SonicUserData>;
  isSelect: boolean;
};

const DBListTeam: React.FC<Props> = ({ teams, owners, isSelect }) => {
  const { t } = useTranslation();

  if (teams.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["team-list"]}`}
      >
        <div>チーム名</div>
        <div>公開状況</div>
        <div>{isSelect === true ? "会員名" : "学生氏名"}</div>
        <div>メールアドレス</div>
        <div>アクション</div>
      </div>
      {teams?.map((team, i) => (
        <div
          className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["team-list"]}`}
          key={i}
        >
          <div>
            {isSelect && checkForJikeiRoles(owners?.[i]?.roles) ? (
              <span className={styles["userType"]}>{"滋"}</span>
            ) : null}
            {team.name}
          </div>
          <div>
            <span
              className={
                team.status === "PUBLICLY_VISIBLE"
                  ? `${styles["status"]} ${styles["open"]}`
                  : team.status === "NOT_PUBLICLY_VISIBLE"
                  ? `${styles["status"]} ${styles["close"]}`
                  : `${styles["status"]} ${styles["pending"]}`
              }
            >
              {t(`status.${team.status}`)}
            </span>
          </div>
          <div>
            {!isSelect && owners?.[i]?.meta?.full_name
              ? owners?.[i]?.meta?.full_name
              : owners?.[i]?.meta?.name}
          </div>
          <div>{owners?.[i]?.meta?.email}</div>
          <ActionBtn
            label="詳細"
            icon={["fal", "edit"]}
            link={
              isSelect
                ? `/admin/database/team/${team.id}`
                : `/jikei/team/${team.id}`
            }
          />
        </div>
      ))}
    </div>
  );
};

export default DBListTeam;
